<template>
    <div class="table-list house-group-list">
        <edit-house-group :houseGroupInfo="selectedHouseGroupInfo"></edit-house-group>
        <modal class="del-role" :display="modalState.delHouseGroupModal" @modalStatus="closeModal('delHouseGroupModal')" >
            <img class="alarm-img" src="@/assets/img/icon/modal_alarm.svg" alt="">
            <h1>刪除房源群組</h1>
            <div class="content">
                確定要刪除“{{selectedHouseGroupInfo.houseGroupName}}”房源群組嗎？確定後將直接刪除此房源群組
            </div>
            <div class="btn-group">
                <button class="default-button" @click="delHouseGroup()">確認</button>
                <button class="border-button" @click="closeModal('delHouseGroupModal')">取消</button>
            </div>
        </modal>
        <div class="mask"></div>
        <div class="table-list-title">
            <span class="name">群組名稱</span>
            <span class="landlord">房東</span>
            <span class="count">房源數量</span>
            <span class="create-date">建立時間</span>
            <span class="action">操作</span>
        </div>
        <div class="table-list-body">
            <div v-if="isLoading" class="filter-empty">
                <table-loading />
            </div>
            <div v-else-if=" filterByWord.length == 0 && houseGroup.length != 0" class="filter-empty">
                <span>0 個搜尋結果</span>
                <!-- <button class="default-button" @click="setFilterDefault">清除篩選</button> -->
            </div>
            <div v-else-if="houseGroup.length == 0" class="is-empty">0 筆資料</div>
            <ul v-else>
                <li v-for="(list,index) in filterByWord" :key="index">
                    <span class="name">{{list.houseGroupName}}</span>
                    <span class="landlord">{{list.landlordName}}</span>
                    <span class="count">{{list.houseAmount}}</span>
                    <span class="create-date">{{getFormatDateTime(list.createdDate)}}</span>
                    <span class="action">
                        <dot-drop-menu>
                            <ul>
                                <li @click="$router.push({name: 'bizEditHouseGroup', query:{cid: list.houseGroupId,address: list.houseGroupAddress, name: list.houseGroupName}})">編輯房源群組</li>
                                <li @click="modalState.delHouseGroupModal = true,selectedHouseGroupInfo.houseGroupId = list.houseGroupId, selectedHouseGroupInfo.houseGroupName = list.houseGroupName">刪除房源群組</li>
                            </ul>
                        </dot-drop-menu>
                    </span>
                </li>
            </ul>
        </div>
    </div>
</template>
<script>
import DotDropMenu from '@/components/widge/DotDropMenu.vue';
import Modal from '@/components/widge/Modal.vue';
import tableLoading from '@/components/bussiness/widges/tools/tableLoading.vue';
import { mapGetters } from 'vuex'

export default {
    data () {
        return{
            alart: {
                success: false,
                fail: false
            },
            msg: {
                success: null,
                error: null,
            },
            modalState: {
                delHouseGroupModal: false
            },
            selectedHouseGroupInfo: {
                houseGroupId: null,
                houseGroupName: null,
            },
            isLoading: true,
        }
    },
    props: {
        
    },
    watch: {
         
    },
    created () {
        this.getHouseGroupMgtList();
    },
    methods: {
        getHouseGroupMgtList: function () {
            this.$store.dispatch('getBizHouseGroupMgtList')
            .then(()=>{
                this.isLoading = false
            })
        },
        setFilterDefault: function () {
        
        },
        // 刪除角色
        delHouseGroup: function () {
            this.$analyticsBiz.logEvent('刪除房源群組', { screen_name: '刪除房源群組'})
            let data = {
                "houseGroupId": this.selectedHouseGroupInfo.houseGroupId
            }
            this.$store.dispatch('delBizHouseGroup', data)
            .then(res => {
                this.modalState.delHouseGroupModal = false
            })
        },
        // 關閉角色modal
        closeModal: function () {
            this.modalState.delHouseGroupModal = false
        },
    },
    computed: {
        filterByWord: function () {
            return this.houseGroup.filter((item) => {
                if( this.filterWord ){
                    if( item.houseGroupName.includes(this.filterWord) || item.landlordName.includes(this.filterWord)){
                        return item
                    }
                }else{
                    return item
                }
            });
        },
        ...mapGetters({
            houseGroup: 'GET_BIZ_HOUSE_GROUP_MGT_LIST',
            filterWord: 'GET_BIZ_HOUSE_GROUP_MGT_FILTER_WORD',
        })
    },
    components: {
        DotDropMenu,
        Modal,
        tableLoading
    }
}
</script>
<style lang="scss">
    .table-list.house-group-list{
        margin-bottom: 150px;
        .name{
            width: 265px;
            margin-right: 153px;
        }
        .landlord{
            width: 72px;
            margin-right: 123px;
        }
        .count{
            width: 56px;
            margin-right: 153px;
        }
        .create-date{
            width: 72px;
            margin-right: 153px;
        }
        .action{
            width: 28px;
        }

        #modal.del-role{
            .modal-content{
                padding: 0 !important;
                .alarm-img{
                    margin-top: 40px;
                }
                h1{
                    font-size: 24px;
                    margin-top: 12px;
                    margin-bottom: 16px;
                }
                .content{
                    padding: 0 40px;
                    width: 368px;
                    line-height: 1.57;
                    color: #a8a5a4;
                    text-align: center;
                    margin-bottom: 50px;
                }
                .btn-group{
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: 100%;
                    height: 84px;
                    box-shadow: 0 4px 20px 0 rgba(37, 38, 94, 0.1);
                    border-radius:  0 0 20px 20px;
                    margin: 0 auto;
                    button{
                        width: 184px;
                        height: 44px;
                    }
                    button:first-child{
                        margin-right: 14px;
                    }
                }
            }
        }
    }
    @media screen and (max-width: 1280px){
        // .table-list.house-group-list{
            
        // }
    
    }
</style>


// WEBPACK FOOTER //
// src/components/bussiness/mgtCategory/houseGroupMgt/houseGroupMgtComp.vue